import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import i18n from "../../i18n";
import DateFilter from "../ui/DateFilter";
import LoadingSpinner from "../Loading";

import InventoryWiseTable from "./Tables/InventoryWiseTable";
import GroupWiseTable from "./Tables/GroupWiseTable";
import CategoryWiseTable from "./Tables/CategoryWiseTable";

import InventorySaleSummaryTable from "../../app/inventory/InventorySaleSummary/InventorySaleSummaryTable";
import InventorySaleReport from "./InventorySaleReport";
import CategoryWiseReport from "./CategoryWiseReport";
import GroupSaleReport from "./GroupSaleReport";
import DiscountWiseReport from "./DiscountWiseReport";
import SalesmanReport from "../../app/settings/Salesman/SalesmanReport";
import OfferWiseReport from "./OfferWiseReport"
import DeliveryBoyReport from "../../app/settings/DeliveryBoy/DeliveryBoyReport";

const CashierSalesReports = () => {
  const { t } = useTranslation();

  const [selected, setSelected] = useState("Inventory Wise");
  const [loading, setLoading] = useState(false);
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";

  const showCategorySalesReport = contractType !== "Cashier"

  const handleToggle = (_, value) => {
    if (value) {
      setSelected(value);
    }
  };

  return (
    <div className="flex min-h-screen w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-6">
      <div>
        <Navbar heading={t("Cashier Sales Reports")} />
      </div>

      <div className="px-2 py-3 sm:px-3">
        {/* Toggle */}
        <div className="mb-4 mt-3 w-auto">
          <div className="inline-flex gap-2 overflow-x-auto rounded-lg border bg-white p-2 scrollbar-hide">
            {[
              { value: "Inventory Wise", label: "Inventory Wise Sale" },
              { value: "Group Wise", label: "Group Wise Sale" },
              ...(showCategorySalesReport
                ? [{ value: "Category Wise", label: "Category Wise Sale" }]
                : []),
              { value: "Discount Wise", label: "Discount Wise Sale" },
              { value: "Offer Wise", label: "Offer Wise Sale" },
              { value: "Salesman Wise", label: "Salesman Wise Sale" },
              // { value: "Delivery Boy Wise", label: "Delivery Boy Wise Sale" },
            ].map((item) => (
              <button
                key={item.value}
                onClick={() => setSelected(item.value)}
                className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-all ${selected === item.value
                    ? "border border-sky-400 bg-sky-400 text-white"
                    : "text-gray-600 hover:bg-gray-100"
                  }`}
              >
                {t(item.label)}
              </button>
            ))}
          </div>
        </div>
        {/* Loader */}
        {loading ? (
          <div className="flex justify-center py-10">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {selected === "Inventory Wise" && <InventorySaleReport />}

            {selected === "Group Wise" && <GroupSaleReport />}

            {selected === "Category Wise" && showCategorySalesReport && <CategoryWiseReport />}

            {selected === "Discount Wise" && <DiscountWiseReport />}
            {selected === "Offer Wise" && <OfferWiseReport />}
            {selected === "Salesman Wise" && <SalesmanReport />}
            {/* {selected === "Delivery Boy Wise" && <DeliveryBoyReport />} */}
          </>
        )}
      </div>
    </div>
  );
};

export default CashierSalesReports;
